export enum WorkflowStatusId {
  ZUR_FREIGABE_VORGELEGT = 1,
  ZURUECKGEWIESEN = 2,
  FREIGEGEBEN = 3,
  OFFEN = 4,
}

export const WorkflowStatusLabel: Record<WorkflowStatusId, string> = {
  [WorkflowStatusId.ZUR_FREIGABE_VORGELEGT]: 'Zur Freigabe vorgelegt',
  [WorkflowStatusId.ZURUECKGEWIESEN]: 'Zurückgewiesen',
  [WorkflowStatusId.FREIGEGEBEN]: 'Freigegeben',
  [WorkflowStatusId.OFFEN]: 'Offen',
};
